<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel-local" @click.stop>
                <div class="dialog-title" v-t="'message.title_bell_duplicate'"/>
                <hr class="dialog-hr">
                <div class="confirm-body" v-html="$t('message.info_bell_duplicate', { objectName: this.originalBellInfo.name})"/>
                <el-form label-width="160px" @submit.native.prevent="save()">
                    <div class="confirm-body" style="padding: 0 20px;">
                        <el-form-item prop="newBellName" ref="newBellName">
                            <div slot="label" style="text-align:left" v-t="'message.item_bell_new_id'"></div>
                            <el-input id="newBellName" v-model="inputForm.newBellName.value" type="text"
                                      clearable :maxlength="constants.BELL_MAX_NAME_LENGTH" show-word-limit
                                      @compositionstart.native="compositionStart()"
                                      @compositionend.native="compositionEnd()"
                                      @input.native="inputCheck()" @clear="inputCheck()"/>
                        </el-form-item>
                    </div>
                    <div class="confirm-body" style="color: #848991;">
                        <div v-t="$t('message.info_bell_duplicate_notice1')"/>
                        <div v-t="$t('message.info_bell_duplicate_notice2')"/>
                    </div>
                    <hr class="dialog-hr">
                    <div class="dialog-button-field">
                        <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                        <el-button :disabled="disableSave" class="dialog-ok-button" native-type="submit">OK</el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </transition>
</template>

<script>
import commonValidate from './common-validate';
import constants from "./constants";

export default {

    props: {
        bellInfo: Object,
    },

    data() {
        return {
            originalBellInfo: null,
            disableSave: false,
            inputForm: {
                newBellName: {
                    validationRule: "bellName",
                    valid: false,
                    value: null,
                    isComposing: false
                },
            }
        };
    },

    computed: {
        constants() {
            return constants
        }
    },

    created() {
        this.originalBellInfo = this.bellInfo;
        this.inputForm.newBellName.value = this.originalBellInfo.name + "_COPY"
        this.inputCheck()
    },

    methods: {
        setButtonStatus() {
            this.disableSave = !commonValidate.checkFormValidation(this.inputForm);
        },
        inputCheck() {
            if (this.inputForm.newBellName.isComposing) {
                // inputting with IME
                return;
            }
            let validateResult = commonValidate.validateItem(this.$i18n, this.inputForm.newBellName.validationRule, this.inputForm.newBellName.value);
            if (validateResult.valid) {
                this.inputForm.newBellName.valid = true;
                if (this.$refs.newBellName) {
                    this.$refs.newBellName.clearValidate();
                }
            } else {
                this.inputForm.newBellName.valid = false;
                if (this.$refs.newBellName) {
                    this.$refs.newBellName.validateState = "error";
                    this.$refs.newBellName.validateMessage = validateResult.message;
                }
            }
            this.setButtonStatus();
        },
        compositionStart() {
            this.inputForm.newBellName.isComposing = true;
        },
        compositionEnd() {
            this.inputForm.newBellName.isComposing = false;
            this.inputCheck()
        },
        save() {
            this.$emit('save', this.originalBellInfo, this.inputForm.newBellName.value);
        },
    }
}
</script>

<style scoped>
.small-panel-local {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 600px;
    max-height: 80vh;
    margin-top: -40vh;
    margin-left: -300px;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -webkit-overflow-scrolling: touch;
}

</style>
